// removed by extract-text-webpack-plugin
module.exports = {"ccList":"_3KzQXWeUgmQpBFbeIDJIr4"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/common/CreditCardList/CreditCardList.css
// module id = 952
// module chunks = 0